import React, { useEffect, useState } from 'react';
import { Row, Col, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { ListCard } from '../../components/ListCard/ListCard';
import { useAuthContext } from '../../contexts/AuthContext';
import { useErrorMessage } from '../../utils/ErrorMessage';

const { Option } = Select;

const ListArticles = () => {
  const { t } = useTranslation();
  const { message } = useErrorMessage();
  const { dispatchAPI } = useAuthContext();
  const [regionalDirections, setRegionalDirections] = useState(null);
  const [selectRD, setSelectRD] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const getRegionalDirection = async () => {
    setIsLoading(true);
    try {
      const { data } = await dispatchAPI('GET', {
        url: `/regionaldirections`
      });
      setRegionalDirections(data);
    } catch (e) {
      message(e);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    (async () => {
      await getRegionalDirection();
    })();
  }, []);

  const headers = [
    {
      label: 'principal',
      key: 'principal'
    },
    {
      label: 'introducy',
      key: 'introducy'
    },
    {
      label: 'content',
      key: 'content'
    },
    {
      label: 'created_at',
      key: 'created_at'
    },
    {
      label: 'updated_at',
      key: 'updated_at'
    }
  ];

  const dataKeys = {
    card: {
      title: '',
      extraTitle: '',
      alt: 'principal',
      src: 'photo'
    },
    meta: {
      title: 'principal',
      extraTitle: 'created_at',
      description: 'introducy',
      content: 'content'
    }
  };

  return (
    <ListCard
      resourceName="articles"
      populate="regionalDirection"
      dataKeys={dataKeys}
      headers={headers}
      resourceModelName="Article"
      extraQuery={selectRD && `&regionalDirection=${selectRD}`}
      showTitle={false}
      numberOfCards={3}
      withImportButton={false}
      extraButtons={
        <Row gutter={[8, 0]}>
          <Col>
            <Select
              loading={isLoading}
              style={{ width: 250, marginRight: 25 }}
              placeholder={t('articles.buttons.selectRD')}
              onSelect={(data) => {
                setSelectRD(data);
              }}
            >
              {(regionalDirections || []).map((sp) => (
                <Option key={sp._id} value={sp._id}>
                  {sp.name}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>
      }
    />
  );
};

export default ListArticles;
